import activityStatus from '../json/activityStatus.json';
import paticipateState from '../json/paticipateState.json';
import {Utils} from "../../../tools/utils";

// 获取活动状态
export const getActivityStatus = code => {
  code += '';
  return activityStatus[code];
};

// 获取参与状态
export const getaticipateState = code => {
  code += '';
  return paticipateState[code];
};

//活动是否有效
export const isActive = (status ='') => {
  status = status ? status + '' : '';
  return ['1','2','3',].filter(key => key === status).length > 0;
};

// 转换成<br />形式的换行
export const getDescToBR = (desc = '') => {
  if (!desc) return '';
  return desc.replace(/\r{0,}\n/g, "<br/>")
};
// 登录管理员是否属于商户（不是机构）
export const isMechant = () => {
  const { companyLevelId } = Utils.getUserData();
  return companyLevelId === '10005';
};
// 格式化为千分位
export const toFix0 = num => {
  if (!num) return 0;
  return (num *= 1).toLocaleString()
};
// 活动插码，产品经理要求的接口上进行埋点（后台统计）
export const getAnalysisData = () => {
  return {
    "platform": encodeURIComponent("商户平台"),
    "app": "",
    "module": encodeURIComponent("活动"),
    "source": encodeURIComponent("商户平台"),
    "uid": Utils.getUserData().userId || '',
    "timestamp": new Date().getTime(),
  }
};
